import { h } from '@atomify/jsx';

const ErrorPageIllustration = () => (
    <svg
        width="154"
        height="131"
        viewBox="0 0 154 131"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M108.846 24.3842L108.661 24.1654V3H124.787V37.3025L108.846 24.3842ZM140.913 50.3701V131H58.2677H40.126H24V50.3701L82.3242 1.55273"
            fill="#F7F7F7"
        />
        <path
            d="M140 50V130H58H40H24V50M108.183 24.2171L108 24V3H124V37.0345L108.183 24.2171Z"
            stroke="#9B9B9B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="4 6"
        />
        <path d="M89 80H82V84H89V80Z" fill="#E6E6E6" />
        <path d="M85 55H78V59H85V55Z" fill="#E6E6E6" />
        <path d="M93 55H86V59H93V55Z" fill="#E6E6E6" />
        <path d="M81 90H74V94H81V90Z" fill="#E6E6E6" />
        <path d="M81 110H74V114H81V110Z" fill="#E6E6E6" />
        <path d="M89 95H82V99H89V95Z" fill="#E6E6E6" />
        <path d="M65 65H58V69H65V65Z" fill="#E6E6E6" />
        <path d="M93 45H86V49H93V45Z" fill="#E6E6E6" />
        <path d="M73 65H66V69H73V65Z" fill="#E6E6E6" />
        <path d="M81 115H74V119H81V115Z" fill="#E6E6E6" />
        <path d="M77 55H70V59H77V55Z" fill="#E6E6E6" />
        <path d="M105 65H98V69H105V65Z" fill="#E6E6E6" />
        <path d="M81 50H74V54H81V50Z" fill="#E6E6E6" />
        <path d="M85 85H78V89H85V85Z" fill="#E6E6E6" />
        <path d="M97 50H90V54H97V50Z" fill="#E6E6E6" />
        <path d="M97 60H90V64H97V60Z" fill="#E6E6E6" />
        <path d="M81 95H74V99H81V95Z" fill="#E6E6E6" />
        <path d="M85 45H78V49H85V45Z" fill="#E6E6E6" />
        <path d="M93 70H86V74H93V70Z" fill="#E6E6E6" />
        <path d="M97 80H90V84H97V80Z" fill="#E6E6E6" />
        <path d="M101 55H94V59H101V55Z" fill="#E6E6E6" />
        <path d="M89 90H82V94H89V90Z" fill="#E6E6E6" />
        <path d="M89 110H82V114H89V110Z" fill="#E6E6E6" />
        <path d="M77 45H70V49H77V45Z" fill="#E6E6E6" />
        <path d="M89 105H82V109H89V105Z" fill="#E6E6E6" />
        <path d="M81 105H74V109H81V105Z" fill="#E6E6E6" />
        <path d="M69 55H62V59H69V55Z" fill="#E6E6E6" />
        <path d="M89 75H82V79H89V75Z" fill="#E6E6E6" />
        <path d="M65 60H58V64H65V60Z" fill="#E6E6E6" />
        <path d="M93 85H86V89H93V85Z" fill="#E6E6E6" />
        <path d="M89 115H82V119H89V115Z" fill="#E6E6E6" />
        <path d="M101 70H94V74H101V70Z" fill="#E6E6E6" />
        <path d="M97 75H90V79H97V75Z" fill="#E6E6E6" />
        <path d="M73 60H66V64H73V60Z" fill="#E6E6E6" />
        <path d="M89 50H82V54H89V50Z" fill="#E6E6E6" />
        <path d="M105 60H98V64H105V60Z" fill="#E6E6E6" />
        <path d="M97 65H90V69H97V65Z" fill="#E6E6E6" />
        <path d="M73 50H66V54H73V50Z" fill="#E6E6E6" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M81 115V119H74V115H81ZM89 115V119H82V115H89ZM89 110V114H82V110H89ZM81 110V114H74V110H81ZM89 105V109H82V105H89ZM81 105V109H74V105H81ZM89 95V99H82V95H89ZM81 95V99H74V95H81ZM81 90V94H74V90H81ZM89 90V94H82V90H89ZM85 85V89H78V85H85ZM93 85V89H86V85H93ZM89 80V84H82V80H89ZM97 80V84H90V80H97ZM89 75V79H82V75H89ZM97 75V79H90V75H97ZM93 70V74H86V70H93ZM101 70V74H94V70H101ZM105 65V69H98V65H105ZM65 65V69H58V65H65ZM73 65V69H66V65H73ZM97 65V69H90V65H97ZM97 60V64H90V60H97ZM65 60V64H58V60H65ZM73 60V64H66V60H73ZM105 60V64H98V60H105ZM85 55V59H78V55H85ZM93 55V59H86V55H93ZM77 55V59H70V55H77ZM101 55V59H94V55H101ZM69 55V59H62V55H69ZM81 50V54H74V50H81ZM97 50V54H90V50H97ZM89 50V54H82V50H89ZM73 50V54H66V50H73ZM93 45V49H86V45H93ZM85 45V49H78V45H85ZM77 45V49H70V45H77Z"
            fill="black"
            fill-opacity="0.05"
        />
        <path
            d="M12.0001 60C2.00006 70 82.0001 2 82.0001 2L152.944 61"
            stroke="#9B9B9B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-dasharray="4 6"
        />
        <path d="M151 129H0V131H151V129Z" fill="#9B9B9B" />
    </svg>
);

export { ErrorPageIllustration };
